import React from "react";
import { Box } from "@mui/material";
import { GlobalTabCollection, StyledTab } from "../../../pages/styles";
import WorkRequestMasterData from "./WorkRequestMasterData";
import WorkRequestManagement from "./WorkRequestManagement";

const WorkRequestAdminMenu = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <WorkRequestManagement></WorkRequestManagement>
      }
      case 1: {
        return <WorkRequestMasterData></WorkRequestMasterData>
      }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff"}}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Work Request Facility' />
            <StyledTab label='Master Data' />
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default WorkRequestAdminMenu;
